import { useApi } from '@/hooks/useApi';
import { CONTROLLERS } from '@/mockData/controllers';
import { useModeAwareQuery } from './useModeAwareQuery';

interface CreditControllerApi {
  id: number;
  firstName: string;
  lastName: string;
}

export interface CreditControllerOption {
  id: string;
  name: string;
}

const demoCreditControllers: CreditControllerOption[] = CONTROLLERS.map((x) => ({
  id: x.id,
  name: x.name,
}));

interface CreditControllersListOptions {
  enabled?: boolean;
  requireFreshData?: boolean;
}

export function useCreditControllersList({
  enabled = true,
  requireFreshData = false,
}: CreditControllersListOptions = {}) {
  const { apiGet } = useApi();

  return useModeAwareQuery<CreditControllerOption[], Error>(
    ['company-credit-controllers'],
    async ({ signal }) => {
      const response = await apiGet<CreditControllerApi[]>(
        '/api/v1/users/company/credit-controllers',
        undefined,
        signal,
      );

      return response.map((x) => ({
        id: String(x.id),
        name: `${x.firstName} ${x.lastName}`.trim(),
      }));
    },
    demoCreditControllers,
    {
      enabled,
      // Credit-controller assignment is an authorization fact that must be
      // resolved against the backend, so dashboard validation always queries
      // Live regardless of the screen's demo toggle and never trusts a cache.
      forceLive: requireFreshData,
      staleTime: requireFreshData ? 0 : 5 * 60 * 1000,
      refetchOnMount: requireFreshData ? 'always' : undefined,
    },
  );
}
